var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: !0, configurable: !0, writable: !0, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key != "symbol" ? key + "" : key, value);
import DateTime from "../../../../../vendor/luxon/src/datetime.js";
import "../../../../../vendor/luxon/src/duration.js";
class Validator {
  constructor() {
    __publicField(this, "disableFuture", !1);
    __publicField(this, "disablePast", !1);
    __publicField(this, "fn", (value) => {
      const [month, day, year] = value.split("/"), monthParsed = Number(month), dayParsed = Number(day), yearParsed = Number(year);
      let mm = month, dd = day, yyyy = year, yearIsValid, monthIsValid, dayIsValid;
      isNaN(monthParsed) || (monthParsed > 12 ? (mm = "mm", monthIsValid = !1) : monthIsValid = !0), isNaN(dayParsed) || (dayParsed > 31 ? (dd = "dd", dayIsValid = !1) : dayIsValid = !0);
      const now = DateTime.now();
      if (isNaN(yearParsed) || (this != null && this.disableFuture && yearParsed > now.year || this != null && this.disablePast && yearParsed < now.year ? (yyyy = "yyyy", yearIsValid = !1) : yearIsValid = !0), yearIsValid && dayIsValid && monthIsValid) {
        const date = DateTime.fromObject({
          month: monthParsed,
          year: yearParsed,
          day: dayParsed
        });
        date.isValid && (date > now && this.disableFuture || date < now && this.disablePast) && (mm = "mm", dd = "dd", yyyy = "yyyy", dayIsValid = !1, monthIsValid = !1);
      }
      return {
        value: `${mm}/${dd}/${yyyy}`,
        year: yearIsValid,
        month: monthIsValid,
        day: dayIsValid
      };
    });
  }
}
export {
  Validator
};
//# sourceMappingURL=dateValidator.js.map
